/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function swatchClick(el) {
  // console.log("click swatch", el);
  // console.log($(el).parent().children()[1]);
  // $('.ColorSwatch').css('border','none');
  // $($(el).parent().children()[1]).css('border',"1px solid");
//     alert(attribute);
};
(function(){
  var productReviewStars = document.querySelector('.ProductMeta .reviews-badge ');
  if (productReviewStars) {
    productReviewStars.addEventListener('click', function(){
      var prodReviews = document.querySelector(".review-section");
      var elementOffset =  prodReviews.getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'))
      window.scrollBy({ top: elementOffset, behavior: 'smooth' });

    })
  }
})();

function toggleClass(element, _class){
  if(!element) return;
  if(element.className.indexOf(_class) == -1 ){
    element.className = element.className + ' ' + _class;
  }else{
    element.className = element.className.replace(_class,'');
  }
}

//New navigation handles
(function(){

  //open submenus
  var banner_items = document.querySelectorAll('.banner-item a[has-dropdown]');
  for(var i=0; i < banner_items.length; i++){
    (function(index){
      var item = banner_items[index];
        item.addEventListener('click', function(){
          var parent_banner_item = item.parentElement;
          var parent_nav = parent_banner_item.parentElement;
          console.log('parent_banner_item ', parent_banner_item)
          console.log('parent_nav ', parent_nav)
          toggleClass(parent_nav, 'has-dropdown-open');
          toggleClass(parent_banner_item, 'open');
          setTimeout(function(){ 
            console.log('parent_banner_item ', parent_banner_item)
            parent_banner_item.style.cssText= "transition: transform 0.2s ease 0s; transform:translateX(0px);";          
          },100)
          document.getElementById('sidebar-menu').classList.add('open-submenu')
      });
    })(i); 
  }

  //close submenus
  var close_submenus = document.querySelectorAll('.Submenu__Close');
  for(var i=0; i < close_submenus.length; i++){
    var close_btn = close_submenus[i];
    close_btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var parent_nav =document.querySelector('nav.has-dropdown-open');
      var parent_banner_item = document.querySelector('.banner-item.open');
      parent_banner_item.style="";
      toggleClass(parent_nav, 'has-dropdown-open');
      toggleClass(parent_banner_item, 'open');
      document.getElementById('sidebar-menu').classList.remove('open-submenu');
      return;
    });
  }

})();


//collection nav slider toggle
(function(){
  var toggleAction = document.querySelector('.toggle-slider');
  if(toggleAction){
    toggleAction.addEventListener('click', function(){
        toggleClass(toggleAction, 'disable');
        toggleClass(toggleAction, 'enable');
        var slider= document.querySelector('.bubbles-wrapper');
        toggleClass(slider, 'mobile-slider');
        window.dispatchEvent(new Event('resize') );
    });
  }
})();

// set link for FAQ in footer
(function(){
    const lang = document.querySelector('html').getAttribute('lang');
    const link = document.querySelector('#link-faq')
     if(lang == 'en'){
      link.setAttribute('href', 'https://hey-marly-support.gorgias.help/en-US')
    } else if (lang == 'fr'){
      link.setAttribute('href', 'https://hey-marly-support-fr.gorgias.help/fr-FR')
    }
  })();

window.addEventListener("load", function(){
  console.log('loaded', document.querySelector('#sidebar-cart'))
  document.querySelector('#sidebar-cart').addEventListener('click', function(e){
      var target = e.target;
      console.log(e.target)
      if(target.parentElement.className  == 'upsell-add new-one')
        target = target.parentElement;
      if(target.className != 'upsell-add new-one' )
        return;

        console.log(target.dataset.variant_id)

      var id = target.dataset.variant_id,
          type = target.dataset.type,
          revenu = target.dataset.value;
      if(!id)
        return;
      var addToCartButton = e.target;
      addToCartButton.setAttribute('disabled', true);
      //update analytics
      console.log('GA plus clicked')
      ga('send', {
        hitType: 'event',
        eventCategory: 'Upsell',
        eventAction: 'Plus Clicked',
        nonInteraction: true,
        eventValue: revenu
      });
      //update cart
      fetch('/cart/add.js', {
            body: JSON.stringify({
               items: [{
                 id:id,
                 quantity:1,
                 properties:{
                   "upsell-item":true,
                   'upsell-type': type
                 }
               }]
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {

            if (response.ok) {
               addToCartButton.removeAttribute('disabled');
               // We simply trigger an event so the mini-cart can re-render
               document.dispatchEvent(new CustomEvent('product:added', {
               bubbles: true,
               detail:{
                  variant: id,
                  quantity: 1
               }
               }));

            } else {
               response.json().then(function (content) {
               var errorMessageElement = document.createElement('span');
               errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
               errorMessageElement.innerHTML = content['description'];
               addToCartButton.removeAttribute('disabled');
               addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
               setTimeout(function () {
                  errorMessageElement.remove();
               }, 2500);
               });
            }

          });

    })
  // }

});
